import { Component } from 'react';

class Footer extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <div className="footer">
                <img className="footer-icon" src="/static/img/gddash_logo1.png" alt="logo" />
                Powered by
                <img className="footer-icon" src="/static/img/newzdash-icon.svg" alt="logo" />
            </div>
        );
    }
}

export default Footer;
